import { atom } from 'recoil';

export interface InventoryFilter {
	image: string;
	filter: string;
	alt: string;
	enabled: boolean;
	tooltipOverride?: string;
}

export const initialFilters: InventoryFilter[] = [
	{
		image: '/images/combat/attack_icon.png',
		filter: 'armor|weapon|key|consumable',
		alt: 'combat',
		enabled: false,
	},
	{
		image: '/images/ui/equipment_icon.png',
		filter: 'armor|weapon|equipment',
		alt: 'equipment',
		enabled: false,
	},
	{ image: '/images/misc/elite/Elite_Scroll_Chaos.png', filter: 'elite', alt: 'scroll', enabled: false },
	{ image: '/images/misc/keys/Complete_Disc.png', filter: 'dungeon|fragment', alt: 'dungeon', enabled: false },
	{ image: '/images/mining/iron_pickaxe.png', filter: 'mining', alt: 'mining', enabled: false },
	{ image: '/images/foraging/foraging_icon.png', filter: 'foraging', alt: 'foraging', enabled: false },
	{ image: '/images/fishing/fishing_logo.png', filter: 'fishing', alt: 'fishing', enabled: false },
	{ image: '/images/farming/farming_icon.png', filter: 'farming', alt: 'farming', enabled: false },
	{ image: '/images/cooking/cooking_icon.png', filter: 'cooking', alt: 'cooking', enabled: false },
	{ image: '/images/runecrafting/mind_rune.png', filter: 'rune', alt: 'rune', enabled: false },
	{ image: '/images/smithing/smithing_icon.png', filter: 'smithing', alt: 'smithing', enabled: false },
	{ image: '/images/combat/equipment/range/arrow_0.png', filter: 'ammo', alt: 'ammo', enabled: false },
	{ image: '/images/misc/geode.png', filter: 'chest', alt: 'chest', enabled: false },
	{
		image: '/images/ui/blocked_icon.png',
		filter: 'clear filters',
		alt: 'clear filters',
		enabled: false,
		tooltipOverride: 'Clear all filters',
	},
	{
		image: '/images/ui/options_gear.png',
		filter: 'toggle location',
		alt: 'toggle location',
		enabled: false,
		tooltipOverride: 'Toggle filter location',
	},
];

export const inventoryFiltersAtom = atom<InventoryFilter[]>({
	key: 'inventoryFiltersAtom',
	default: initialFilters,
});
